import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/member/user_list',
	ADD: '/member/user_add',
	UPDATE: '/member/user_update',
	VEST_FIND: '/member/user_vest_find',
	VEST_LIST: '/member/user_vest_list',
	
	RECHARGE_LIST: '/member/user_recharge_list',
	CASHOUT_LIST: '/member/user_cashout_list',
	CALL_LIST: '/member/user_call_list',
	ADD_WEIGHT: '/member/user_add_weight',
	ADJUST_GOLD: '/member/user_adjust_gold',
	DETAIL: '/member/user_detail',
    UPDATE_STATUS: '/member/user_update_status',
}

export async function userList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function userAdd(queryParams) {
    return requestPost(api.ADD, queryParams);
}

export async function userUpdate(queryParams) {
    return requestPost(api.UPDATE, queryParams);
}

export async function userRechargeList(queryParams) {
    return requestGet(api.RECHARGE_LIST, queryParams);
}

export async function userCashoutList(queryParams) {
    return requestGet(api.CASHOUT_LIST, queryParams);
}

export async function userCallList(queryParams) {
    return requestGet(api.CALL_LIST, queryParams);
}

export async function vestUserFind(name) {
    let params = {
        name: name
    };
    return requestGet(api.VEST_FIND, params);
}

export async function userVestList(queryParams) {
    return requestGet(api.VEST_LIST, queryParams);
}

export async function userAddWeight(payload) {
    return requestPost(api.ADD_WEIGHT, payload);
}

export async function userAdjustGold(payload) {
    return requestPost(api.ADJUST_GOLD, payload);
}

export async function userDetail(id) {
    return requestGet(api.DETAIL, { id });
}

export async function userUpdateStatus(id, status) {
    return requestPost(api.UPDATE_STATUS, { id, status });
}